<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
</style>
<template lang="pug">
  FormSection(
    :printOut="printOut"
    title="Guide Information"
    description="The hope of this section is to help us identify areas of your life story that might aid a Young Adult looking for a particular kind of connection."
  )
    .frow.column-start.mb-25
      .field(v-if="printOut")
        div(v-if="user.tags && user.tags.length > 0")
          .tags-heading Conversation Themes:
          span.tag.clr-bg-primary(v-text="tag" v-for="tag in user.tags")
      .field(v-else)
        .label.reset Conversation Themes
        small.mb-10 Check 3-5 boxes to identify themes for conversations you’d be interested in having with Young Adults.
        .frow
          label.theme.col-md-1-6(v-for="option in options")
            .frow
              input(
                v-model="user.tags"
                :value="option"
                type="checkbox"
              )
              p {{ option }}
    TextAreaInput(
      v-model="user.experiences"
      :printOut="printOut"
      example="I was cheated on and nearly arrested to start my 20s. I was struggling to establish my identity and partying a lot before I found an anchor in Christ. Since becoming a Christian, I’ve been through multiple job changes, some tense experiences with extended family (including a teen pregnancy with my sister and the ‘coming out’ of my brother ..."
      name="experiences"
      question="Are there experiences from your own Young Adulthood that might be beneficial in making a connection to a Young Adult who could be experiencing something similar?"
    )
    TextAreaInput(
      v-model="user.calling"
      :printOut="printOut"
      example="Navigating Major Transitions, Setting Goals, Crafting a Life Rhythm, Life as Newlyweds, Relationships with In-Laws, Discerning Spiritual Next Steps, Maturing as a Christian Young Adult"
      name="calling"
      question="Are there areas of Young Adulthood that you feel particularly called and equipped to speak into?"
    )
</template>
<script>
import FormSection from "@/new-components/GuideForm/FormSection";
import YesNo from "@/new-components/GuideForm/YesNo";
import TextInput from "@/new-components/GuideForm/TextInput";
import TextAreaInput from "@/new-components/GuideForm/TextAreaInput";
export default {
  name: "guide-information",
  components: {
    FormSection,
    YesNo,
    TextInput,
    TextAreaInput
  },
  props: {
    user: {
      type: Object
    },
    printOut: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [
      "Career",
      "Finances",
      "Family",
      "Friendships",
      "Stress",
      "Anxiety",
      "Volunteering",
      "Faith",
      "Habits",
      "Marriage",
      "Dating",
      "Struggles"
    ]
  })
};
</script>
